import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../../../../context/UserContext';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import FieldDate from '../../../../components/FieldDate/FieldDate';
import ButtonDefault from '../../../../components/ButtonDefault/ButtonDefault';
import { API } from '../../../../API/API';
import { MessageConst } from '../../../../const/MessageConst';
import { Col, message, Row } from 'antd';
import { hideLoadScreen, showLoadScreen } from '../../../../components/LoadScreen/LoadScreen';
import FieldNumberFormat from '../../../../components/FieldNumberFormat/FieldNumberFormat';
import { constData } from '../../../../const/Const';
import PanelBase from '../../../../components/PanelBase/PanelBase';
import moment from 'moment';
import FieldItemListAdd from '../../../../components/FieldItemListAdd/FieldItemListAdd';

const BenefitNewBusiness = (props) => {

    const { userInfo } = useContext(UserContext);
    const [vsysdate] = useState(moment().format('YYYY.MM.DD hh:mm:ss').toString());
    const [initialData] = useState({
        "companyid": userInfo.companyid.toUpperCase(),
        "empid": props.empid > 0 ? props.empid : null,
        "extraid": null,
        "count": 0,
        "begindate": vsysdate,
        "enddate": null,
        "isactive": true,
    });
    const [data, setData] = useState({ ...initialData });
    const [warning, setWarning] = useState();
    const [loading, setLoading] = useState(false);
    const [checkReq, setCheckReq] = useState(false);

    const [showConfirm, setShowConfirm] = useState(false);

    const getData = async () => {

        let tData = {};
        if (props.entryid > 0) {
            try {
                setLoading(true);
                await API.get('/api/payroll/additional/getempextra?entryid=' + props.entryid).then(response => {
                    if (response.status == 200 && response.data.retType == 0) {
                        if (response.data?.retData) {
                            tData = response.data.retData;
                        }
                    }
                });
            } finally {
                setLoading(false);
            }

        } else {
            tData = { ...initialData };
            if (props.empid > 0) {
                tData.empid = props.empid;
            }
        }
        setData(tData);
    }

    useEffect(() => {
        getData();
    }, [props.entryid, props.empid]);

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }
            setData(tData);
        }
    }

    const onPressSave = async () => {
        setWarning(null);
        setCheckReq(true);

        let isValid = true;

        if (!data.empid) {
            isValid = false;
            setWarning("Ажилтан сонгох" + MessageConst.fieldRequired);
        } else if (!data.extraid) {
            isValid = false;
            setWarning("Нэмэгдлийн нэр" + MessageConst.fieldRequired);
        } else if (data.count <= 0) {
            isValid = false;
            setWarning("Нэмэгдлийн хэмжээ" + MessageConst.fieldRequired);
        } else if (!data?.calctype) {
            isValid = false;
        }

        if (isValid) {
            showLoadScreen();

            let isExists = false;
            let existsMsg = '';
            // await API.post('/api/humanresource/payroll/check_emp_extra', [data]).then(response => {
            //     if (response.status === 200 && response.data.rettype === 0) {
            //         if (response.data.retdata?.length > 0) {
            //             isExists = true;
            //             existsMsg = response.data.retdata[0].message;
            //         }
            //     }
            // });

            if (isExists && !showConfirm) {
                setShowConfirm(true);
                setWarning(existsMsg);
            } else {
                await saveData();
            }

            hideLoadScreen();
        }
    }

    const saveData = async () => {
        await API.post('/api/payroll/additional/setempextras', data).then(response => {
            if (response.status === 200 && response.data.retType == 0) {
                clearState();
                message.success(MessageConst.success);
                props.afterSave();
            }
        });
    }

    const onDeleteBenefit = async () => {
        showLoadScreen();
        await API.delete('/api/payroll/additional/deleteempextra?entryid=' + props?.entryid).then(response => {
            if (response.status == 200 && response.data.retType == 0) {
                message.success(MessageConst.success);
                props.afterSave();
            }
        });
        hideLoadScreen();
    }

    const onDismiss = () => {
        clearState();
        props.onDismiss();
    }

    const clearState = () => {
        setShowConfirm(false);
        setCheckReq(false);
        setWarning(null);
        setData({ ...initialData });
    }

    return (
        <div>
            <PanelBase
                isOpen={props.isOpen}
                onDismiss={onDismiss}
                headerText={props?.entryid > 0 ? "Нэмэгдэл засах" : "Нэмэгдэл нэмэх"}
                isFooterAtBottom={true}
                onDelete={onDeleteBenefit}
                warning={warning}
                delete={props?.entryid}
                buttons={
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ButtonDefault onClick={onPressSave} text="Хадгалах" />
                    </div>
                }
            >
                <div style={{ marginTop: 13 }}>
                    <FieldItemListAdd required loading={loading} title="Нэмэгдэл" onChanged={fieldOnChanged} keyfield='extraid' keyfieldname='extraname' defaultValue={[{ key: data.extraid, name: data.extraname }]} checkreq={checkReq} dataurl="/api/payroll/additional/getextradropdown" saveurl="/api/payroll/additional/setextras" />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown required onChanged={fieldOnChanged} title="Тооцох төрөл" data={constData.hrExtra_CalcType} keyfield='calctype' defaultValue={data.calctype} checkreq={checkReq} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <Row gutter={[16, 16]}>
                        <Col span={20}>
                            <FieldNumberFormat required title={"Нэмэгдлийн хэмжээ" + (data.infimum > -1 && data.supremum ? "(" + data.infimum + "-" + data.supremum + ")" : "")} onChanged={fieldOnChanged} keyfield='count' defaultValue={data.count} checkreq={checkReq} />
                        </Col>
                        <Col span={4}>
                            <FieldDropdown disable={true} title="&nbsp;" data={constData.hrExtra_CalcType_Symbol} keyfield='calctypesymbol' defaultValue={data.calctype} />
                        </Col>
                    </Row>
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDropdown title="Давтамж" onChanged={fieldOnChanged} data={constData.hrExtra_Frequency} keyfield='frequency' defaultValue={data.frequency} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate title="Эхэлсэн огноо" onChanged={fieldOnChanged} keyfield='begindate' defaultValue={data.begindate} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldDate title="Дуусах огноо" onChanged={fieldOnChanged} keyfield='enddate' defaultValue={data.enddate} />
                </div>
            </PanelBase >
        </div >
    );
}

export default BenefitNewBusiness;